module.exports = "/_next/static/images/9b5c4a6a9a9b8bb08b4681f8a4b9ce6d-mastercard-right-lg.jpg.webp";